import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, dark = false, id }) => (
  <Reveal>
    <p data-testid={`${id}-eyebrow`} className={`font-mono-ed text-xs uppercase tracking-[0.3em] ${dark ? "text-banana" : "text-mango"}`}>
      {eyebrow}
    </p>
    <h2 data-testid={`${id}-title`} className={`font-display mt-4 text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-3xl ${dark ? "text-paper" : "text-jungle"}`}>
      {title}
    </h2>
  </Reveal>
);
